module.exports = __webpack_public_path__ + "img/kv.c94ad76f.jpg";